<template>
  <send-form :can-back="true" @submit.prevent="doSend" @back="toPrivacyPolicy">
    <form-caption v-if="pageTitle" :text="pageTitle" />
    <p>
      お客様のアカウントを登録します。<br>
      メールアドレスを入力して送信してください。<br>
      送信すると登録ページのご案内メールが届きます。<br>
      メール本文に記載されているURLから、本登録を行ってください。<br>
    </p>
    <vuex-email-form-item label="メールアドレス" bind="email" />
  </send-form>
</template>
<script>
import SendForm from "@/views/templates/forms/SendForm";
import FormCaption from '@/views/atoms/FormCaption'
import VuexEmailFormItem from "@/views/molecules/formItems/VuexEmailFormItem";

export default {
  name: 'EmailRegister',
  components: {
    SendForm,
    FormCaption,
    VuexEmailFormItem,
  },
  provide: {
    bindModule: 'provisional_brokerage_company_form'
  },
  computed: {
    pageTitle() {
      return this.$store.state.pageTitle;
    },
  },
  mounted() {
    this.$store.commit('provisional_brokerage_company_form/resetData');
    this.$store.commit('provisional_brokerage_company_form/clearError');
  },
  methods: {
    doSend() {
      this.$store.commit('provisional_brokerage_company_form/setManagementCompanyCode', localStorage.getItem('managementCompanyCode'));
      this.$store.dispatch('provisional_brokerage_company_form/send').then(() => {
        this.$root.showFlashMessage();
      }).catch(reason => this.$root.failApi(reason));
    },
    toPrivacyPolicy() {
      this.$router.push({name: 'PrivacyPolicyAgreement'});
    },
  }
}
</script>
